export default __webpack_public_path__ + "static/media/TurboIcon.aef3cec8.svg";